import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="ac-footer">
      <div className="ac-width">
        <div className="ac-footer-main">
          <div>
            <Link to="/" className="ac-logo"><img src="/favicon.svg" alt="" width="40" height="40" /><span>Allcom.zone</span></Link>
            <p>Česká komunita pro všechny.</p>
            <a className="ac-text-link" href="https://evobug.com">Součást Evobugu</a>
          </div>
          <nav aria-label="Allcom odkazy">
            <a href="/#about">O nás</a><a href="/#community">Komunita</a><a href="/#events">Akce</a>
            <a href="/#faq">Časté otázky</a><Link to="/shop">Shop</Link>
          </nav>
          <nav aria-label="Discord a další projekty">
            <a href="https://discord.allcom.zone" target="_blank" rel="noopener noreferrer">Připojit se na Discord</a>
            <Link to="/discord">Discord dokumentace</Link>
            <a href="https://evobug.com/timeline">Historie Evobugu a Allcomu</a>
            <a href="https://evobug.games">Projekty Evobugu</a>
          </nav>
        </div>
        <div className="ac-footer-bottom">
          <p>© {new Date().getFullYear()} Allcom.zone. Všechna práva vyhrazena.</p>
          <a href="#page-top">Zpět nahoru</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
